import { Button } from "../../../ui/button";
import { ArrowUpDown } from "lucide-react";
import { Badge } from "../../../ui/badge";
import { format } from "date-fns";
import DataTableRowActions from "../Feature/DataTableRowAction";

export const columns = ({ onEdit, onDelete, onSort }) => [

  {
    accessorKey: "name",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="px-0 py-0"
          onClick={() => onSort("Name")}
        >
          Tên chiến dịch
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const name = row.getValue("name");
      return <div className="w-52 line-clamp-2 ">{name}</div>;
    },
  },
  
  {
    accessorKey: "amount",
    header: ({ column }) => (
      <Button
        className="px-0 py-0"
        variant="ghost"
        onClick={() => onSort("Amount")}
      >
        Số tiền đã đạt
        <ArrowUpDown className="ml-2 h-4 w-4" />
      </Button>
    ),
    cell: ({ row }) => {
      const donationAmount = parseFloat(row.getValue("amount"));
      const formatted = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "VND",
      }).format(donationAmount);

      return <div className="text-start font-medium">{formatted}</div>;
    },
  },

  {
    accessorKey: "bankingName",
    header: ({ column }) => (
      <Button
        className="px-0 py-0"
        variant="ghost"
        onClick={() => onSort("BankingName")}
      >
        Tên ngân hàng
        <ArrowUpDown className="ml-2 h-4 w-4" />
      </Button>
    ),
    cell: ({ row }) => {
      const bankingName = row.original?.bankingName;
      return <div className="line-clamp-1">{bankingName}</div>;
    },
  },
  {
    accessorKey: "donatePhaseIsEnd",
    header: ({ column }) => (
      <Button
        className="px-0 py-0"
        variant="ghost"
        onClick={() => onSort("DonatePhaseIsEnd")}
      >
        Trạng thái quyên góp 
        <ArrowUpDown className="ml-2 h-4 w-4" />
      </Button>
    ),
    cell: ({ row }) => {
      const donatePhaseIsEnd = row.getValue("donatePhaseIsEnd");
      return (
        <div className="w-max">
          {donatePhaseIsEnd === true ? (
            <Badge variant="success">Đã kết thúc</Badge>
          ) : (
            <Badge variant="destructive">Chưa kết thúc</Badge>
          )}
        </div>
      );
    },
  },

  {
    accessorKey: "accountName",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          className="px-0 py-0"
          onClick={() => onSort("AccountName")}
        >
          Tên tài khoản
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
  },

  // Thêm Actions vào columns
  {
    id: "actions",
    cell: ({ row }) => (
      <DataTableRowActions row={row} onEdit={onEdit} onDelete={onDelete} />
    ),
  },
];
